<div class="dialog-heading add-margin-bottom">
    <h5>{{ data.title }}</h5>
    <span class="flex-fill"></span>
    <mat-icon class="close-dialog" aria-hidden="false" [mat-dialog-close]="{ confirmed: false }"
        aria-label="Close icon"> close</mat-icon>
</div>

<mat-dialog-content [formGroup]="shareQuoteForm" class="font-size">
    <div>
      <mat-tab-group>

        <mat-tab label="Send a Link">
          <p>
            Choose which data you would like to export to the web link for the customer to view. The user will
            be able to view and select their favorite offer.
          </p>
          <app-share-quote-configuration formGroupName="configuration"></app-share-quote-configuration>
          <div class="field-message" *ngIf="shareQuoteForm.get('configuration').touched && shareQuoteForm?.get('configuration').hasError('nocheckboxes')" style="margin-top: 10px; color: #bb0000; font-size: 11.25px;">
            Please select at least one quote detail
          </div>
          <div class="share-info">
            <mat-form-field id="share-url" appearance="standard" *ngIf="shareQuote">
              <mat-label>Web Link</mat-label>
              <input matInput value="{{shareQuote.url}}" disabled>
            </mat-form-field>
            <button mat-flat-button color="accent" id="share-button"
                    (click)="copyLink()"
                    [cdkCopyToClipboard]="shareQuote.url"
                    *ngIf="shareQuote"
                    #tooltip="matTooltip"
                    matTooltip="Copy to Clipboard"
                    matTooltipPosition="right">
              Copy Link
            </button>
            <button mat-flat-button color="accent" id="share-generate" (click)="generateLink()"
                    *ngIf="!shareQuote" [disabled]="!hasCheck()">
              Generate URL
            </button>
          </div>
          <div>
            <label class="small-label">Note: Please ensure you only send the link to the intended recipient(s).</label>
          </div>
        </mat-tab>
        <mat-tab label="Send an Email" #emailTab="matTab">
          <p>
            Choose which data you would like to export to the web link for the customer to view. The user will
            be able to view and select their favorite offer.
          </p>
          <app-share-quote-configuration formGroupName="configuration"></app-share-quote-configuration>

          <div class="field-message" *ngIf="shareQuoteForm.get('configuration').touched && shareQuoteForm?.get('configuration').hasError('nocheckboxes')" style="margin-top: 10px; color: #bb0000; font-size: 11.25px;">
            Please select at least one quote detail
          </div>
          <div>
            <mat-form-field class="full-width" appearance="standard">
              <mat-label>Email </mat-label>
              <input matInput formControlName="customerEmail">
              <mat-error *ngIf="
                        shareQuoteForm.get('customerEmail').hasError('email')
                        || shareQuoteForm.get('customerEmail').hasError('required')">
                Please enter an email address
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <label class="small-label">Note: Please ensure you only send the link to the intended recipient(s).</label>
          </div>
        </mat-tab>
        <mat-tab label="Export to Excel">
          <p>
            Choose which data you would like to export to Excel for the customer to view.
          </p>
          <app-share-quote-configuration formGroupName="configuration"></app-share-quote-configuration>
          <div class="field-message" *ngIf="shareQuoteForm.get('configuration').touched && shareQuoteForm?.get('configuration').hasError('nocheckboxes')" style="margin-top: 10px; color: #bb0000; font-size: 11.25px;">
            Please select at least one quote detail
          </div>
          <div class="share-info">
            <button mat-flat-button color="accent" id="share-generate" (click)="downloadExportedData()"
                   [disabled]="!hasCheck()">
              Download
            </button>
          </div>
          <div>
            <label class="small-label">Note: Please ensure you only share the file with the intended recipient(s).</label>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

</mat-dialog-content>

<!-- This are the actions of the dialog, containing the primary and the cancel button-->

<mat-dialog-actions class="actions">
    <button mat-flat-button color="accent" (click)="sendEmail()" *ngIf="emailTab.isActive"
        >Send Email</button>
    <button mat-stroked-button color="accent" [mat-dialog-close]="{ confirmed: false }">Cancel</button>
</mat-dialog-actions>
